/**
 * @module cercaliagl/Notification
 */
import VNotification from './view/VNotification';
/**
 * @type {Object.<string, string>}
 * @api
 */
export var Severity = {
    /**
     * @api
     */
    INFO: 'info',
    /**
     * @api
     */
    WARNING: 'warning',
    /**
     * @api
     */
    ERROR: 'error',
};
/**
 * @classdesc
 * Create a styled notification with a message, severity and a duration.<br/>
 * @api
 */
var Notification = /** @class */ (function () {
    /**
     * @param {string} message Message.
     * @param {string=} [severity] Severity.
     * <ul>
     *  <li><b>cercaliagl.Notification.Severity.INFO</b>: Info severity, value: <code>info</code></li>
     *  <li><b>cercaliagl.Notification.Severity.WARNING</b>: Warning severity, value: <code>warning</code></li>
     *  <li><b>cercaliagl.Notification.Severity.INFO</b>: Error severity, value: <code>error</code></li>
     * </ul>
     * @param {number=} duration Duration.
     */
    function Notification(message, severity, duration) {
        if (severity === void 0) { severity = Severity.INFO; }
        if (duration === void 0) { duration = 5000; }
        /**
         * @private
         * @type {VNotification}
         */
        this.vNotification_ = new VNotification(message, severity);
        /**
         * @private
         * @type {Element}
         */
        this.element_ = this.vNotification_.getElement();
        /**
         * @private
         * @type {string}
         */
        this.message_ = message;
        /**
         * @private
         * @type {string}
         */
        this.severity_ = severity;
        /**
         * @private
         * @type {number}
         */
        this.duration_ = duration;
        this.element_.setAttribute('severity', this.severity_);
        this.element_.setAttribute('message', this.message_);
        this.element_.setAttribute('duration', "".concat(this.duration_));
    }
    /**
     * Display notification on map.
     * @param {Map|Element} mapOrElement Map or HTML Element
     * @api
     */
    Notification.prototype.display = function (mapOrElement) {
        var _this = this;
        var container;
        if (mapOrElement instanceof Element) {
            container = mapOrElement;
        }
        else {
            var mbMap = mapOrElement.getMapboxglMap();
            container = mbMap.getCanvas().parentElement;
        }
        this.vNotification_.appendTo(container);
        setTimeout(function () {
            container.removeChild(_this.element_);
        }, this.duration_);
    };
    /**
     * Get HTML element.
     * @return {Element} HTML Element
     * @api
     */
    Notification.prototype.getElement = function () {
        return this.element_;
    };
    return Notification;
}());
export default Notification;
//# sourceMappingURL=Notification.js.map